//表单校验

export default {
  //用户名
  login_name: (rule, value, callback) => {
    if (value.trim().length < 5) {
      callback(new Error("用户名必填，至少五位"));
    } else {
      callback();
    }
  },

  login_name_mobile: (rule, value, callback) => {
    let reg = /^1\d{10}/;
    if (!reg.test(value)) {
      callback(new Error("手机号码格式不正确"));
    } else {
      callback();
    }
  },

  //密码
  password: (rule, value, callback) => {
    if (value === "") {
      callback(new Error("密码必填"));
    }
    //let reg = /^.*(?=.{6,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/;
    let reg = /.{6,16}/;
    if (!reg.test(value)) {
      callback(new Error("6-16位"));
    } else {
      callback();
    }
  }
};
